import { Box, Flex, Text } from '@chakra-ui/react'
import { useContext } from 'react'
import { AiOutlineHistory } from 'react-icons/ai'
import { useHistory } from 'react-router-dom'
import { useDetailLinkBase } from '../../../../hooks/useDetailLinkBase'
import { MLContext } from '../../../../providers'

interface Props {
  versionId: string
  fileId: string
}

const VersionContainer = ({ versionId, fileId }: Props): React.ReactElement => {
  const [{ detailPageVersions }] = useContext(MLContext)
  const history = useHistory()
  const { background } = useDetailLinkBase()

  const go = (e: React.MouseEvent): void => {
    e.preventDefault()
    e.stopPropagation()
    history.replace({
      pathname: `/media-library/detail/${fileId}/${versionId}`,
      state: {
        background,
      },
    })
  }

  return (
    <Flex
      as="a"
      onClick={go}
      cursor="pointer"
      background="#F5F7F9"
      border="1px solid #E1E4EB"
      borderRadius="16px"
      height="24px"
      align="center"
      color="#1A202C"
      maxW="105px"
      _hover={{
        border: '1px solid #CDDCF7',
        background: 'appPaleGreyTwo',
        color: 'appBlue',
      }}
    >
      <Box ml="8px">
        <AiOutlineHistory />
      </Box>
      <Box mr="8px">
        <Text ml="8px" fontWeight="500" fontSize="12px">
          {detailPageVersions.find(file => file.versionInfo.id === versionId)
            ?.versionInfo.name ?? versionId}
        </Text>
      </Box>
    </Flex>
  )
}

export default VersionContainer
